const { useEffect } = require("react");

const useScrollTop = ({ behavior = "auto", changeCase } = {}) =>
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [behavior, changeCase]);

export default useScrollTop;
